<template>
  <div>
    <div :id="elementId"></div>
    <div
      v-show="errors.length"
      :id="`${elementId}-error`"
      class="body-smaller base-input-v2__error-container">
      <div class="base-input-v2__error">
        <oie-base-icon icon="warning" size="xs"></oie-base-icon>
        <span v-for="error in errors" :key="error"> {{ error }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const SITEKEY = '6Le4RFMpAAAAAJK3rqfaGdmSZwz2uZuAPMzJRFs7'
const SCRIPT_URL = 'https://www.google.com/recaptcha/api.js'
const SHARED_CALLBACK = 'onRecaptchaLoad'

// Shared across all instances — queue of render functions waiting for the script
const pendingRenderers = []
let scriptInjected = false

window[SHARED_CALLBACK] = () => {
  pendingRenderers.forEach(fn => fn())
  pendingRenderers.length = 0
}

let instanceCounter = 0

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: null,
      required: false
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      elementId: `oie-recaptcha-${++instanceCounter}`
    }
  },
  mounted() {
    this.initRecaptcha()
  },
  methods: {
    initRecaptcha() {
      if (window.grecaptcha && window.grecaptcha.render) {
        // Script already loaded — render immediately
        this.renderWidget()
      } else {
        // Queue render for when script loads
        pendingRenderers.push(() => this.renderWidget())

        if (!scriptInjected) {
          scriptInjected = true
          // Only inject the script once
          const script = document.createElement('script')
          script.src = `${SCRIPT_URL}?onload=${SHARED_CALLBACK}&render=explicit`
          script.async = true
          script.defer = true
          document.head.appendChild(script)
        }
        // else: script is already loading, callback will fire when ready
      }
    },
    renderWidget() {
      window.grecaptcha.render(this.elementId, {
        sitekey: SITEKEY,
        callback: (response) => {
          this.$emit('input', response)
        },
        'expired-callback': () => {
          this.$emit('input', null)
        }
      })
    },
    reset() {
      if (window.grecaptcha) {
        window.grecaptcha.reset()
      }
      this.$emit('input', null)
    }
  }
}
</script>
